import api from "@/api/creditnotes";

const state = () => ({
  createProposalOpen: false,
  createCreditNoteProposalLoading: false,
  createCreditNoteProposalError: false,
  createCreditNoteProposalErrorResponse: null,

  creditNoteFilters: [],
  creditNoteFiltersLoading: false,
  creditNoteHistory: [],
  creditNoteHistoryLoading: false,
  creditNoteReasons: [],
  creditNoteReasonsLoading: false,
  creditNoteDepartments: [],
  creditNoteDepartmentsLoading: false,
  creditNotesProposals: [],
  creditNotesProposalsLoading: false,
  creditNotesProposalsError: null,
  creditNotesProposalsConfig: {
    paginationCount: 0,
    paginationLimit: 50,
    paginationPage: 1,
    createdStart: "",
    createdEnd: "",
    accountId: "",
    billCycle: [],
    productKind: [],
    amountFrom: "",
    amountTo: "",
    shortReason: [],
    departments: [],
    agents: [],
    approvalStatus: [],
    approvers: [],
    approvalDateStart: "",
    approvalDateEnd: "",
    preApprovalStatus: [],
    preApprovers: [],
    preApprovalDateStart: "",
    preApprovalDateEnd: "",
  },
  creditNotesProposalsActionAccount: {},
  updateCreditNotesProposalsLoading: false,
  exportCredNoteProposalsLoading: false,

  toggleEditLineItemsDialog: false,
  adhocInvoices: [],
  lineItems: [],
  totalCreditAmount: 0,
  fetchAdhocInvoicesLoading: false,
  fetchAdhocInvoicesError: false,
  fetchAdhocInvoicesErrorResponse: null,
});

const mutations = {
  setCreateProposalOpen(state,data) { 
    state.createProposalOpen = data; 
  },

  CREATE_CREDIT_NOTE_PROPOSAL_BEGIN(state) {
    state.createCreditNoteProposalLoading = true;
    state.createCreditNoteProposalError = false;
    state.createCreditNoteProposalErrorResponse = null;
  },
  CREATE_CREDIT_NOTE_PROPOSAL_SUCCESS(state) {
    state.createCreditNoteProposalLoading = false;
  },
  CREATE_CREDIT_NOTE_PROPOSAL_ERROR(state, err) {
    state.createCreditNoteProposalLoading = false;
    state.createCreditNoteProposalError =  true;
    state.createCreditNoteProposalErrorResponse = err;
  },

  setCreditNoteReasons(state,data){
    state.creditNoteReasons = data;
    state.creditNoteReasonsLoading = false;
  },
  setCreditNoteFiltersLoading(state,data){ state.creditNoteFiltersLoading = data; },
  setCreditNoteFilters(state,data){
    state.creditNoteFilters = data;
    state.creditNoteFiltersLoading = false;
  },
  
  setCreditNoteReasonsLoading(state,data){ state.creditNoteReasonsLoading = data; },
  setCreditNoteHistory(state,data){
    state.creditNoteHistory = data;
    state.creditNoteHistoryLoading = false;
  },
  setCreditNoteHistoryLoading(state,data){ state.creditNoteHistoryLoading = data; },
  setCreditNoteDepartments(state,data){
    state.creditNoteDepartments = data;
    state.creditNoteDepartmentsLoading = false;
  },
  setCreditNoteDepartmentsLoading(state,data){ state.creditNoteDepartmentsLoading = data; },
  setCreditNotesProposals(state, payload) {
    state.creditNotesProposals = payload.data;
    state.creditNotesProposalsConfig.paginationCount = parseInt(payload.headers['pagination-count']);
    state.creditNotesProposalsConfig.paginationLimit = parseInt(payload.headers['pagination-limit']);
    state.creditNotesProposalsConfig.paginationPage = parseInt(payload.headers['pagination-page']);
  },
  setCreditNotesProposalsLoading(state,data) { state.creditNotesProposalsLoading = data; },
  setCreditNotesProposalsError(state, payload) {
    state.numberTransfersError = payload;
  },
  updateCreditNotesProposalsPagination(state, payload) {
    state.creditNotesProposalsConfig.paginationLimit = (payload.itemsPerPage!==undefined)?payload.itemsPerPage:state.creditNotesProposalsConfig.paginationLimit;
    state.creditNotesProposalsConfig.paginationPage = (payload.page)?payload.page:state.creditNotesProposalsConfig.paginationPage;
    state.creditNotesProposalsConfig.accountId = (payload.accountId!==undefined)?payload.accountId:state.creditNotesProposalsConfig.accountId;
    state.creditNotesProposalsConfig.billCycle = (payload.billCycle!==undefined)?payload.billCycle:state.creditNotesProposalsConfig.billCycle;
    state.creditNotesProposalsConfig.productKind = (payload.productKind!==undefined)?payload.productKind:state.creditNotesProposalsConfig.productKind;
    state.creditNotesProposalsConfig.departments = (payload.departments!==undefined)?payload.departments:state.creditNotesProposalsConfig.departments;
    state.creditNotesProposalsConfig.amountFrom = (payload.amountFrom!==undefined)?payload.amountFrom:state.creditNotesProposalsConfig.amountFrom;
    state.creditNotesProposalsConfig.amountTo = (payload.amountTo!==undefined)?payload.amountTo:state.creditNotesProposalsConfig.amountTo;
    state.creditNotesProposalsConfig.shortReason = (payload.shortReason!==undefined)?payload.shortReason:state.creditNotesProposalsConfig.shortReason;
    state.creditNotesProposalsConfig.agents = (payload.agents!==undefined)?payload.agents:state.creditNotesProposalsConfig.agents;
    state.creditNotesProposalsConfig.approvalStatus = (payload.approvalStatus!==undefined)?payload.approvalStatus:state.creditNotesProposalsConfig.approvalStatus;
    state.creditNotesProposalsConfig.approvers = (payload.approvers!==undefined)?payload.approvers:state.creditNotesProposalsConfig.approvers;
    state.creditNotesProposalsConfig.preApprovalStatus = (payload.preApprovalStatus!==undefined)?payload.preApprovalStatus:state.creditNotesProposalsConfig.preApprovalStatus;
    state.creditNotesProposalsConfig.preApprovers = (payload.preApprovers!==undefined)?payload.preApprovers:state.creditNotesProposalsConfig.preApprovers;
    state.creditNotesProposalsConfig.createdStart = (payload.created!==undefined&&payload.created.length>0)?`${payload.created[0]} 00:00`:"";
    state.creditNotesProposalsConfig.createdEnd = (payload.created!==undefined&&payload.created.length>1)?`${payload.created[1]} 23:59`:"";
    state.creditNotesProposalsConfig.preApprovalDateStart = (payload.preApprovalDate!==undefined&&payload.preApprovalDate.length>0)?`${payload.preApprovalDate[0]} 00:00`:"";
    state.creditNotesProposalsConfig.preApprovalDateEnd = (payload.preApprovalDate!==undefined&&payload.preApprovalDate.length>1)?`${payload.preApprovalDate[1]} 23:59`:"";
    state.creditNotesProposalsConfig.approvalDateStart = (payload.approvalDate!==undefined&&payload.approvalDate.length>0)?`${payload.approvalDate[0]} 00:00`:"";
    state.creditNotesProposalsConfig.approvalDateEnd = (payload.approvalDate!==undefined&&payload.approvalDate.length>1)?`${payload.approvalDate[1]} 23:59`:"";
    
  },
  setCreditNotesProposalsActionAccount(state, payload) {
    state.creditNotesProposalsActionAccount = payload;
  },
  setUpdateCreditNoteProposalsLoading(state, payload) {
    state.updateCreditNotesProposalsLoading = payload;
  },
  exportCredNoteProposalsLoading(state, payload) {
    state.exportCredNoteProposalsLoading = payload;
  },

  FETCH_ADHOC_INVOICES_BEGIN(state) {
    state.fetchAdhocInvoicesLoading = true;
    state.fetchAdhocInvoicesError = false;
    state.fetchAdhocInvoicesErrorResponse = null;
  },
  FETCH_ADHOC_INVOICES_SUCCESS(state, payload) {
    state.fetchAdhocInvoicesLoading = false;
    state.adhocInvoices = payload.data;
  },
  FETCH_ADHOC_INVOICES_ERROR(state, err) {
    state.fetchAdhocInvoicesLoading = false;
    state.fetchAdhocInvoicesError = true;
    state.fetchAdhocInvoicesErrorResponse = err;
  },
  UPDATE_LINE_ITEMS(state, payload) {
    state.lineItems = payload.lineItems;
    state.totalCreditAmount = payload.totalCreditAmount;
  },
  TOGGLE_EDIT_LINE_ITEMS_DIALOG(state, payload) {
    state.toggleEditLineItemsDialog = payload;
  },

  RESET_CREDIT_NOTES_PROPOSALS_ACTION_ACCOUNT(state) {
    state.creditNotesProposalsActionAccount = {};
  }
};

const actions = {
  async fetchCreditNoteReasonsByAccount({commit,dispatch},accId){
    commit('setCreditNoteHistoryLoading',true);
    try{
      const res = await api.getCreditNoteProposalsByAccount(accId);
      if(res.status===200){
        commit('setCreditNoteHistory',res.data);
      }else{
        commit('setCreditNoteHistoryLoading',false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit('setCreditNoteHistoryLoading',false);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async fetchCreditNoteReasons({commit,dispatch}){
    commit('setCreditNoteReasonsLoading',true);
    try{
      const res = await api.getCreditNoteReasons();
      if(res.status===200){
        commit('setCreditNoteReasons',res.data);
      }else{
        commit('setCreditNoteReasonsLoading',false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit('setCreditNoteReasonsLoading',false);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async fetchCreditNoteFilters({commit,dispatch}){
    commit('setCreditNoteFiltersLoading',true);
    try{
      const res = await api.getCreditNoteFilters();
      if(res.status===200){
        commit('setCreditNoteFilters',res.data);
      }else{
        commit('setCreditNoteFiltersLoading',false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit('setCreditNoteFiltersLoading',false);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },
  async fetchCreditNoteDepartments({commit,dispatch}){
    commit('setCreditNoteDepartmentsLoading',true);
    try{
      const res = await api.getCreditNoteDepartments();
      if(res.status===200){
        commit('setCreditNoteDepartments',res.data);
      }else{
        commit('setCreditNoteDepartmentsLoading',false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    }catch(err){
      commit('setCreditNoteDepartmentsLoading',false);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },

  async createCreditNoteProposal({commit,dispatch},{id,data}){
    commit('CREATE_CREDIT_NOTE_PROPOSAL_BEGIN');
    try{
      await api.createCreditNoteProposal(id,data);
      commit('CREATE_CREDIT_NOTE_PROPOSAL_SUCCESS');
      dispatch("alerts/setAlert", {type: "success",message: 'Credit note proposal created successfully!'}, { root: true });
    } catch(err){
      commit('CREATE_CREDIT_NOTE_PROPOSAL_ERROR', err);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
    }
  },

  async fetchCreditNoteProposals({ state, commit, dispatch }) {
    commit("setCreditNotesProposalsLoading",true);
    try {
      const res = await api.getCreditNoteProposals(state.creditNotesProposalsConfig);
      if(res.status===200){
        commit("setCreditNotesProposals",res);
      }else{
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    } catch(err) {
      if(err.response.status===403) {
        dispatch("alerts/setAlert", {type:"error",message:'You do not have permissions to view this page.'}, { root: true });
      } else {
        dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      }
      commit("setCreditNotesProposalsError",err);
    }
    commit("setCreditNotesProposalsLoading",false);
  },
  async updateCreditNoteProposalsPagination({ commit, dispatch }, payload) {
    commit("updateCreditNotesProposalsPagination", payload);
    await dispatch("fetchCreditNoteProposals");
  },
  setCreditNotesProposalsActionAccount({ commit }, payload) {
    commit("setCreditNotesProposalsActionAccount", payload);
  },
  async updateCreditNoteProposal({ commit, dispatch }, { id, payload }) {
    commit("setUpdateCreditNoteProposalsLoading", true);
    try {
      const res = await api.updateCreditNoteProposal(id, payload);
      if(res.status === 200) {
        commit("setUpdateCreditNoteProposalsLoading", false);
        dispatch("alerts/setAlert", {type: "success",message: 'Credit note proposal updated successfully!'}, { root: true });
        await dispatch("fetchCreditNoteProposals");
      } else {
        commit("setUpdateCreditNoteProposalsLoading", false);
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
      }
    } catch(err) {
      commit("setUpdateCreditNoteProposalsLoading", false);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      throw err;
    }
  },
  async exportCreditNoteProposals({ state, commit, dispatch }) {
    commit("exportCredNoteProposalsLoading", true);
    try {
      const { data } = await api.exportCreditNoteProposals(state.creditNotesProposalsConfig);
      let blob = new Blob([data], { type: 'text/csv;charset=utf-8;' });
      let url = URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.setAttribute("href", url);
      link.setAttribute("download", `CNP-${new Date().getTime()}.csv`);
      document.body.appendChild(link);
      link.click();

      commit("exportCredNoteProposalsLoading", false);
      dispatch("alerts/setAlert", {type: "success",message: 'Credit note proposal exported successfully!'}, { root: true });
    } catch(err) {
      commit("exportCredNoteProposalsLoading", false);
      dispatch("alerts/setAlert", {type:"error",message:err.response.data.message}, { root: true });
      throw err;
    }
  },

  async fetchAdhocInvoices({ commit }, account_id) {
    commit('FETCH_ADHOC_INVOICES_BEGIN');
    try {
      const data = await api.fetchAdhocInvoices(account_id);
      commit('FETCH_ADHOC_INVOICES_SUCCESS', data);
    } catch(err) {
      commit('FETCH_ADHOC_INVOICES_ERROR', err);
    }
  }
};

const getters = {
  getCreateProposalOpen: state => state.createProposalOpen,
  getCreateCreditNoteProposalLoading: state => state.createCreditNoteProposalLoading,
  getCreateCreditNoteProposalError: state => state.createCreditNoteProposalError,
  getCreateCreditNoteProposalErrorResponse: state => state.createCreditNoteProposalErrorResponse,

  getCreditReasonsLoading: (state)=>state.creditNotesProposalsLoading,
  getCreditNoteReasons: (state)=>{
    return state.creditNoteReasons.sort((a,b) => a.value.localeCompare(b.value)).map(e=>{
      return {text:e.value,value:e.value};
    }); 
  },
  getCreditNoteFilters: (state)=>{
    if(state.creditNoteFilters.agents!==undefined){
      state.creditNoteFilters.agents = state.creditNoteFilters.agents.sort();
      state.creditNoteFilters.approvers = state.creditNoteFilters.approvers.sort();
      state.creditNoteFilters.pre_approvers = state.creditNoteFilters.pre_approvers.sort();
      state.creditNoteFilters.departments = state.creditNoteFilters.departments.sort();
      state.creditNoteFilters.short_reasons = state.creditNoteFilters.short_reasons.sort((a,b) => a.value.localeCompare(b.value));
    }
    return state.creditNoteFilters;
  },
  getCreditNoteHistory: (state)=>{
    return state.creditNoteHistory.map(e=>{return{
      ...e,
      created: e.creation_timestamp,
      agent: e.agent_sid,
      amount: e.amount,
      approval: e.approval_status,
    }});
  },
  getApprovedCreditNoteLineItems: state => {
    return state.creditNoteHistory.filter(note => {
      return note.short_reason === 'Sales Credit' && note.approval_status === 'APPROVED';
    }).reduce((final, item) => {
        return [...final, ...item.line_items];
    }, []);
  },
  getIsCreditNoteLineItemApproved: (state, getters) => id => {
    return getters.getApprovedCreditNoteLineItems.some(approvedItem => approvedItem.adhoc_line_item_id === id);
  },

  getCreditNoteDepartmentsLoading: (state)=>state.creditNoteDepartmentsLoading,
  getCreditNoteDepartments: (state)=>{
    return state.creditNoteDepartments.sort((a,b) => a.value.localeCompare(b.value)).reduce((acc, e)=>{
      let value = e.value;
      if (e.available) {
        acc.push({text:value,value:value});
      }
      return acc;
    }, []);
  },

  getIsCreditNotesProposalsActionAccount: state => Object.keys(state.creditNotesProposalsActionAccount).length,
  getCreditNotesProposalsActionAccount: state => state.creditNotesProposalsActionAccount,
  getFormatLineItems: state => {
    return state.creditNotesProposalsActionAccount.line_items.map(item => {
      return { 
        ...item,
        description: item.adhoc_line_item.product,
        price: item.adhoc_line_item.total / item.adhoc_line_item.quantity,
        creditAmount: -item.amount,
        quantity: item.adhoc_line_item.quantity,
        total: item.adhoc_line_item.total
      }
    })
  },

  getAdhocInvoices: (state, getters) => { 
    return state.adhocInvoices.map(invoice => {
      return {
        ...invoice,
        line_items: invoice.line_items.map(item => {
          return {
            ...item,
            adhoc_line_item_id: item.id,
            description: item.product,
            price: item.total / item.quantity,
            creditAmount: item.creditAmount ? item.creditAmount : item.total,
            approved: getters.getIsCreditNoteLineItemApproved(item.id)
          }
        })
      }
    });
  },
  getToggleEditLineItemsDialog: state => state.toggleEditLineItemsDialog,
  getLineItems: state => state.lineItems, 
  getLineItemsForSubmission: state => {
    return state.lineItems.map(item => {
      return {
        adhoc_line_item_id: item.adhoc_line_item_id,
        amount: -parseFloat(item.creditAmount)
      }
    });
  },
  getTotalCreditAmount: state => state.totalCreditAmount,
  getFetchAdhocInvoicesLoading: state => state.fetchAdhocInvoicesLoading,
  getFetchAdhocInvoicesError: state => state.fetchAdhocInvoicesError,
  getFetchAdhocInvoicesErrorResponse: state => state.fetchAdhocInvoicesErrorResponse,
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
  